// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewcontrolRunId } from './BrewcontrolRun';
import { timeseriesSeriesId } from './TimeseriesSeries';
import { z } from 'zod';
export const brewcontrolRunTagId = (z.number());
export const brewcontrolRunTag = z.object({
    id: brewcontrolRunTagId,
    run_id: brewcontrolRunId,
    tag: z.string(),
    unit: z.string(),
    series_id: timeseriesSeriesId,
    created_at: z.date(),
});
export const brewcontrolRunTagInitializer = z.object({
    id: brewcontrolRunTagId.optional(),
    run_id: brewcontrolRunId,
    tag: z.string(),
    unit: z.string().optional(),
    series_id: timeseriesSeriesId,
    created_at: z.date().optional(),
});
export const brewcontrolRunTagMutator = z.object({
    id: brewcontrolRunTagId.optional(),
    run_id: brewcontrolRunId.optional(),
    tag: z.string().optional(),
    unit: z.string().optional(),
    series_id: timeseriesSeriesId.optional(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=BrewcontrolRunTag.js.map